var exports = {
  "container": "x9bf38834--1c4757--container",
  "row": "x9bf38834--1c4757--row",
  "phone": "x9bf38834--1c4757--phone",
};

module.exports = exports;
